/*
 * Converte um arquivo (File ou Blob) para base64 sem FileReader, para funcionar
 * tanto no navegador quanto no Vitest (Node 18), onde só o Blob existe.
 * A string binária é montada em blocos de 32 KB porque
 * `String.fromCharCode.apply` estoura a pilha quando o array é grande demais
 * para ser passado de uma vez só.
 */
export const arquivoParaBase64 = async (arquivo) => {
    const buffer = await arquivo.arrayBuffer();
    const bytes = new Uint8Array(buffer);

    const tamanhoBloco = 0x8000;
    let binario = '';
    for (let i = 0; i < bytes.length; i += tamanhoBloco) {
        binario += String.fromCharCode.apply(null, bytes.subarray(i, i + tamanhoBloco));
    }

    return btoa(binario);
};
